import { mapState } from 'vuex'

import { getAmenitiesWithFacets } from '@/utils/filters'
import { priceValues } from '@/utils/transformers/filters/prices'
import { areaValues } from '@/utils/transformers/filters/areas'
import { URLS } from '@/utils/constants'

import ozPrices from '@/pages/results/components/filters/components/oz-prices'
import ozAccordionDevelopmentTypes from '@/pages/results/components/filters/oz-filters-mobile/components/oz-accordion-development-types'
import ozAccordionRentalTypes from '@/pages/results/components/filters/oz-filters-mobile/components/oz-accordion-rental-types'
import ozAmount from '@/pages/results/components/filters/components/oz-amount'
import ozAreas from '@/pages/results/components/filters/components/oz-areas'
import ozToggle from '@/components/oz-toggle'
import ozToggleZapway from '@/components/filters/oz-toggle-zapway'
import ozToggleDatazap from '@/components/filters/oz-toggle-datazap'
import ozToggleDisplayAddressType from '@/components/filters/oz-toggle-display-address-type'
import ozToggleTotalPrice from '@/components/filters/oz-toggle-total-price'
import ozListingCode from '@/components/filters/oz-listing-code'
import ozAdvertiserId from '@/components/filters/oz-advertiser-id'
import ozToggleTotalArea from '@/components/filters/oz-toggle-total-area'
import ozBuyingPowerCalculatorButton from '@/pages/results/components/filters/components/oz-buying-power-calculator-button'

import { BUSINESS_TYPE_MAP } from '@/filters/business-type'
import ozAccordionAmenities from '@/pages/results/components/filters/oz-filters-mobile/components/oz-accordion-amenities'

import ozUnitTypes from '../oz-unit-types'
import ozModalFooter from '../oz-modal-footer'

export default {
  name: 'oz-modal-body',

  props: {
    filters: { type: Object, required: true },
    glossary: { type: Object, required: true },
    isResultPage: { type: Boolean },
  },

  data () {
    return {
      currentFilters: {},
      categories: {},
    }
  },

  mounted () {
    this.categories = getAmenitiesWithFacets(this.facets)
  },

  created () {
    const virtualTour = this.handleVirtualTour(this.filters.hasVirtualTour)
    this.currentFilters = { ...this.currentFilters, ...this.filters, ...virtualTour }
  },

  watch: {
    filters () {
      const localFilters = { ...this.currentFilters, ...this.filters }
      if (this.filters.business !== this.currentFilters.business) {
        localFilters.warranties = ''
      }
      this.currentFilters = localFilters
    },
    facets () {
      this.categories = getAmenitiesWithFacets(this.facets)
    },
  },

  computed: {
    ...mapState({
      facets: (state) => state.results.facets,
    }),

    handleUnitType () {
      return this.currentFilters.listingType || 'undefined'
    },

    isRental () {
      const { RENTAL } = BUSINESS_TYPE_MAP
      return this.currentFilters.business === RENTAL
    },

    isSale () {
      const { SALE } = BUSINESS_TYPE_MAP
      return this.currentFilters.business === SALE
    },

    amountTypes () {
      const { bedrooms = '', bathrooms = '', parkingSpaces = '' } = this.currentFilters
      const AMOUNT_TYPES = [
        {
          title: 'Quartos',
          singularTitle: 'quarto',
          model: 'bedrooms',
          filters: bedrooms.toString(),
          class: 'js-bedrooms',
        },
        {
          title: 'Banheiros',
          singularTitle: 'banheiro',
          model: 'bathrooms',
          filters: bathrooms.toString(),
          class: 'js-bathrooms',
        },
        {
          title: 'Vagas',
          singularTitle: 'vaga',
          model: 'parkingSpaces',
          filters: parkingSpaces.toString(),
          class: 'js-parking-spaces',
        },
      ]
      return AMOUNT_TYPES
    },

    rentTotalPrice () {
      const { rentTotalPrice, rentalTotalPriceMin, rentalTotalPriceMax } = this.currentFilters
      return Boolean(rentTotalPrice || rentalTotalPriceMax || rentalTotalPriceMin)
    },

    prices () {
      return priceValues(this.rentTotalPrice, this.currentFilters)
    },

    totalArea () {
      const { totalAreasMin, totalAreasMax } = this.filters
      return Boolean(totalAreasMin || totalAreasMax)
    },

    areas () {
      return areaValues(this.totalArea, this.filters)
    },

    isRoutePathSale () {
      const { params: { pathMatch } } = this.$route
      return pathMatch === URLS.ZAP.MAIN.PATHS.SALE
    },
  },

  methods: {
    onFiltersUpdate (newFilters) {
      this.currentFilters = { ...this.currentFilters, ...newFilters }
    },

    removeFilters () {
      this.$emit('filters:remove')
    },

    onSubmitFilters () {
      this.$emit('filters:update', this.currentFilters)
    },

    handleVirtualTour (virtualTour) {
      const boolVirtualTour = Boolean(virtualTour)
      return boolVirtualTour ? { hasVirtualTour: boolVirtualTour } : {}
    },

    onVirtualTourUpdate (applyTourVitural) {
      if (!applyTourVitural) delete this.currentFilters.hasVirtualTour
      this.onFiltersUpdate(this.handleVirtualTour(applyTourVitural))
    },

    onTransportNearByUpdate (value) {
      const distance = '2'
      this.onFiltersUpdate({ transportNearBy: value ? distance : null })
    },
  },

  components: {
    ozPrices,
    ozAmount,
    ozAccordionAmenities,
    ozAreas,
    ozToggle,
    ozUnitTypes,
    ozToggleZapway,
    ozToggleDatazap,
    ozToggleDisplayAddressType,
    ozToggleTotalPrice,
    ozListingCode,
    ozModalFooter,
    ozAccordionDevelopmentTypes,
    ozAdvertiserId,
    ozAccordionRentalTypes,
    ozToggleTotalArea,
    ozBuyingPowerCalculatorButton,
  },
}
